import { useMaintenanceStatus } from '@phx/maintenance';

import { useFlags } from './use-flags';

/**
 * Convenience hook that combines useFlags and useMaintenanceStatus
 * for use within lilly-direct app.
 *
 * @example
 * ```tsx
 * const { isMaintenanceActive } = useAppMaintenanceStatus();
 * ```
 */
export const useAppMaintenanceStatus = () => {
    const { lillyMaintenanceWindow } = useFlags();
    return useMaintenanceStatus(lillyMaintenanceWindow);
};
